// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footerItem":"footerItem__footerItem--_Fdjw","divider":"footerItem__divider--2BNh-"};